import React, { useEffect } from 'react';

import { Route } from 'react-router-dom';

import Account from 'components/Pages/Account';
import ClientPortal from 'components/Pages/ClientPortal';
import GuestPortal from 'components/Pages/GuestPortal';
import PreviewRoutes from 'components/Pages/Preview';
import ErrorScreen from 'components/shared/ErrorScreen';
import { useCookieYes } from 'hooks/useCookieYes';
import { DOMAINS, getDomain } from 'utils/domain';

import LazyCustomDomain from './components/Pages/CustomDomain';
import FilesPortal from './components/Pages/FilesPortal';
import PropertyPortal from './components/Pages/PropertyPortal';

function RoutesWrapper() {
  useCookieYes();
  const domain = getDomain();

  useEffect(() => {
    document.body.classList.add(`body-domain-${domain}`);

    return () => {
      document.body.classList.remove(`body-domain-${domain}`);
    };
  }, [domain]);

  switch (domain) {
    case DOMAINS.TRAVEL:
      return <PropertyPortal />;
    case DOMAINS.CUSTOM_DOMAIN:
      return <LazyCustomDomain />;
    case DOMAINS.ITINERARIES:
      return <ClientPortal />;
    case DOMAINS.GUEST:
      return <GuestPortal />;
    case DOMAINS.ACCOUNT:
      return <Account />;
    case DOMAINS.FILES:
      return <FilesPortal />;
    case DOMAINS.PREVIEW:
      return <PreviewRoutes />;
    default:
      return <Route component={() => <ErrorScreen status="404" />} />;
  }
}

export default RoutesWrapper;
